import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useHistory } from "../../core/utils";
import FileSaver from "file-saver";

// core
import { API, getURL } from "../../core/api";
import { defaultImage } from "../../core/data";
import { addTomanPriceComma } from "../../core/utils";
import { getSiteName } from "../../core/utils";

// store
import { Actions } from "../../store/actions";

// components
import { Loading } from "../../components/Loading";
import { IsActive } from "../../components/IsActive";
import { Note } from "../../components/Note";
import { Table, Image, Input, Button, Select, Upload, Modal } from "antd";

const { Dragger } = Upload;
const { Column } = Table;
const { Option } = Select;

export const SiteSellerProducts = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [sellerProducts, setSellerProducts] = useState([]);
  const [search, setSearch] = useState(null);
  const [brand, setBrand] = useState(null);
  const [brands, setBrands] = useState([]);
  const [isActive, setIsActive] = useState(null);
  const [category, setCategory] = useState(null);
  const [categories, setCategories] = useState([]);
  const [city, setCity] = useState(null);
  const [cities, setCities] = useState([]);
  const [seller, setSeller] = useState(null);
  const [sellers, setSellers] = useState([]);
  const [pagination, setPagination] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const [file, setFile] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [isUpLoading, setIsUpLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const getBrands = () => {
    API.get
      .brands()
      .then((response) => {
        if (response.success) {
          setBrands(response.data);
        } else {
          Note.error(response.message);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getCategories = () => {
    API.get
      .categories()
      .then((response) => {
        if (response.success) {
          setCategories(response.data);
        } else {
          Note.error(response.message);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getCities = () => {
    API.get
      .cities()
      .then((response) => {
        if (response.success) {
          setCities(response.data);
        } else {
          Note.error(response.message);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getSellers = () => {
    API.get
      .sellers()
      .then((response) => {
        if (response.success) {
          setSellers(response.data);
        } else {
          Note.error(response.message);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getSellerProducts = (
    page,
    limit,
    search,
    brand_id,
    category_id,
    is_active,
    city_id,
    seller_id
  ) => {
    setIsLoading(true);
    API.get
      .seller_products(
        null,
        props.site?.id,
        true,
        page,
        limit,
        search,
        brand_id,
        category_id,
        is_active,
        city_id,
        seller_id
      )
      .then((response) => {
        if (response.success) {
          setSellerProducts(response.data);
          setPagination(response.pagination);
          history.query({
            page: response.pagination.page,
            limit: response.pagination.limit,
            search,
            brand_id,
            category_id,
            is_active,
            city_id,
            seller_id,
          });
          setIsLoading(false);
        } else {
          Note.error(response.message);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    let query = history.query();
    getCities();
    getSellers();
    getBrands();
    getCategories();
    getSellerProducts(
      query.page,
      query.limit,
      query.search,
      query.brand_id,
      query.category_id,
      query.is_active,
      query.city_id,
      query.seller_id
    );
    setIsActive(query.is_active || null);
    setSearch(query.search);
    setBrand(query.brand_id || null);
    setCategory(query.category_id || null);
    setCity(query.city_id || null);
    setSeller(query.seller_id || null);
    // eslint-disable-next-line
  }, []);

  const changePage = (page, limit) => {
    // history.query({ page, limit });
    let query = history.query();
    getSellerProducts(
      page,
      limit,
      query.search,
      query.brand_id,
      query.category_id,
      query.is_active,
      query.city_id,
      query.seller_id
    );
  };

  const filterData = () => {
    setIsLoading(true);
    let query = history.query();
    getSellerProducts(
      query.page,
      query.limit,
      search,
      brand,
      category,
      isActive,
      city,
      seller
    );
  };

  const downloadExcel = () => {
    setIsLoading(true);
    API.get
      .export_seller_products(
        null,
        props.site?.id,
        search,
        brand,
        category,
        isActive,
        city,
        seller
      )
      .then((response) => {
        if (response.status === 200) {
          setIsLoading(false);
          return response.blob();
        } else {
          Note.error(response.message);
          setIsLoading(false);
        }
      })
      .then((blob) => {
        FileSaver.saveAs(blob, `seller-products-site-${props.site?.id}.xlsx`);
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  };

  const onRemove = (file) => {
    setFile(null);
    setFileList([]);
    setIsUpLoading(false);
    setShowConfirmModal(false);
  };

  const beforeUpload = (file) => {
    setFile(file);
    setFileList([file]);
    setShowConfirmModal(true);
    return false;
  };

  const confirmYes = (site_id) => {
    setIsUpLoading(true);
    let formData = new FormData();
    formData.append("excel", file);
    formData.append("site_id", site_id);

    API.put
      .import_seller_products(formData)
      .then((response) => {
        if (response.success) {
          onRemove();
          filterData();
          Note.success(response.message);
        } else {
          onRemove();
          filterData();
          Note.error(response.message);
        }
        try {
          if (response.data?.messages?.length > 0) {
            dispatch(
              Actions.ExcelSummary({
                ...response.data,
                file_name: file.name,
                view: `آپلود کالاهای فروشگاه ${getSiteName(props.site?.name)}`,
              })
            );
            window.open("/excel-summary/", "_blank");
          }
        } catch {
          // pass
        }
      })
      .catch((e) => {
        onRemove();
        console.log(e);
      });
  };

  return (
    <Loading isLoading={isLoading}>
      <Modal
        visible={showConfirmModal}
        footer={null}
        centered={true}
        closable={false}
        destroyOnClose={true}>
        {isUpLoading ? (
          <div className="text-center">
            <Loading />
            <span className="mr-10">در حال آپلود فایل، لطفا صبور باشید!</span>
          </div>
        ) : (
          <div>
            <div className="text-center">
              <div>
                آیا آپلود فایل{" "}
                <span className="color-promotion-s1">{file?.name}</span> برای
                کالاهای فروشگاه {getSiteName(props.site?.name)} را تائید میکنید؟
              </div>
              <small className="color-orange">
                با آپلود این فایل مشخصات کالاهای این فروشگاه تغییر میکند.
              </small>
            </div>
            <div className="flex-row flex-content-space-between mt-15">
              <Button
                className="button-red w-45"
                onClick={() => onRemove(null)}>
                خیر
              </Button>
              <Button
                className="button-promotion w-45"
                onClick={() => confirmYes(props.site?.id)}>
                بله
              </Button>
            </div>
          </div>
        )}
      </Modal>
      <div className="mx-20 mt-15">
        <Dragger
          className="border-black"
          maxCount={1}
          accept=".xls,.xlsx"
          fileList={fileList}
          onRemove={onRemove}
          beforeUpload={beforeUpload}>
          <p>آپلود اکسل کالاهای فروشگاه {getSiteName(props.site?.name)}</p>
          <small className="color-orange">نوع فایل باید xls یا xlsx باشد</small>
        </Dragger>
      </div>
      <div className="site-seller-products-page mb-20">
        <div className="flex-row flex-content-space-between flex-wrap py-10 px-20">
          <Input
            className="input-black border-black w-65 sm:w-100 my-5"
            placeholder="جستجو نام کالا"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <Select
            className="border-black w-30 sm:w-100 my-5"
            showSearch
            optionFilterProp="name"
            value={seller}
            onChange={(value) => setSeller(value)}>
            <Option value={null} name="همه فروشنده‌ها">
              همه فروشنده‌ها
            </Option>
            {sellers.map((seller) => (
              <Option value={seller.id.toString()} name={seller.name}>
                {seller.name}
              </Option>
            ))}
          </Select>
          <Select
            className="border-black w-30 sm:w-100 my-5"
            showSearch
            optionFilterProp="name"
            value={brand}
            onChange={(value) => setBrand(value)}>
            <Option value={null} name="همه برندها">
              همه برندها
            </Option>
            {brands.map((brand) => (
              <Option value={brand.id.toString()} name={brand.name}>
                {brand.name}
              </Option>
            ))}
          </Select>
          <Select
            className="border-black w-30 sm:w-100 my-5"
            showSearch
            optionFilterProp="name"
            value={category}
            onChange={(value) => {
              setCategory(value);
            }}>
            <Option value={null} name="همه دسته‌ها">
              همه دسته‌ها
            </Option>
            {categories.map((category) => (
              <Option value={category.id.toString()} name={category.name}>
                {category.name}
              </Option>
            ))}
          </Select>
          <Select
            className="border-black w-30 sm:w-100 my-5"
            value={isActive}
            onChange={(value) => {
              setIsActive(value);
            }}>
            <Option value={null} name="همه وضعیت‌ها">
              همه وضعیت‌ها
            </Option>
            <Option value={"1"} name="فعال">
              فعال
            </Option>
            <Option value={"0"} name="غیرفعال">
              غیرفعال
            </Option>
          </Select>
          <Select
            className="border-black w-30 sm:w-100 my-5"
            showSearch
            optionFilterProp="name"
            value={city}
            onChange={(value) => setCity(value)}>
            <Option value={null} name="همه شهرها">
              همه شهرها
            </Option>
            {cities.map((city) => (
              <Option value={city.id.toString()} name={city.name}>
                <small className="color-promotion-s1">
                  [{city.province.name}]
                </small>{" "}
                {city.name}
              </Option>
            ))}
          </Select>
          <Button
            className="button-secondary w-30 sm:w-100 my-5"
            onClick={filterData}>
            فیلتر
          </Button>
          <Button
            className="button-primary w-30 sm:w-100 my-5"
            onClick={downloadExcel}>
            دانلود اکسل
          </Button>
        </div>
        <Table
          size="small"
          scroll={{ x: 640 }}
          dataSource={sellerProducts}
          pagination={{
            position: ["bottomCenter"],
            current: pagination.page,
            pageSize: pagination.limit,
            total: pagination.count,
            onChange: changePage,
          }}>
          <Column
            title="تصویر"
            dataIndex="image"
            key="image"
            render={(image) => (
              <Image
                className="product-image"
                src={getURL(image)}
                fallback={defaultImage}
                alt="image"
              />
            )}
          />
          <Column
            title="کد"
            dataIndex="id"
            key="id"
            render={(id) => (
              <Link to={`/sites/${props.site.id}/products/${id}/`}>{id}</Link>
            )}
          />
          <Column
            title="شهر"
            render={(sellerProduct) => (
              <div>
                <small className="color-promotion-s1 mr-10 ml-5">
                  [{sellerProduct.city.province.name}]
                </small>
                <span className="mx-10">{sellerProduct.city.name}</span>
              </div>
            )}
          />
          <Column
            title="فروشنده"
            render={(sellerProduct) => (
              <div>
                <span className="color-orange mx-10">
                  {sellerProduct.seller.name}
                </span>
              </div>
            )}
          />
          <Column
            title="وضعیت"
            render={(sellerProduct) => (
              <div className="flex-row flex-items-center flex-wrap">
                <IsActive value={sellerProduct.is_active} className="ml-5" />
                {sellerProduct.is_buyable ? (
                  <small className="bg-color-promotion color-white border-radius-pill px-10">
                    قابل خرید
                  </small>
                ) : (
                  <small className="bg-color-red color-white border-radius-pill px-10">
                    غیر قابل خرید
                  </small>
                )}
              </div>
            )}
          />
          <Column
            title="نام"
            key="name"
            render={(sellerProduct) => (
              <div>
                <span>{sellerProduct.product.name}</span>
                <Link
                  className="font-size-small mr-10"
                  to={`/products/${sellerProduct.product.id}/`}>
                  [{sellerProduct.product.id}]
                </Link>
              </div>
            )}
          />
          <Column
            title="تخفیف"
            key="discount"
            render={(sellerProduct) =>
              sellerProduct.fixed_discount_amount ? (
                <span>
                  {addTomanPriceComma(sellerProduct.fixed_discount_amount)}{" "}
                  تومان
                  <span className="color-promotion-s1 pr-10">
                    {sellerProduct.discount_percentage} %
                  </span>
                </span>
              ) : (
                <span className="color-orange">ندارد</span>
              )
            }
          />
          <Column
            title="قابل پرداخت"
            key="payable_amount"
            render={(sellerProduct) => (
              <span>
                {addTomanPriceComma(sellerProduct.payable_amount)} تومان
              </span>
            )}
          />
          <Column
            title="موجودی"
            key="stock"
            render={(sellerProduct) =>
              sellerProduct.unlimited_stock ? (
                <span className="color-orange">نامحدود</span>
              ) : (
                <span>
                  {sellerProduct.stock} {sellerProduct.product.unit}
                </span>
              )
            }
          />
          {/* <Column
            title="تاریخ انتشار"
            key="stock"
            render={(sellerProduct) =>
              sellerProduct.release_date ? (
                <span>{sellerProduct.release_date}</span>
              ) : (
                <span className="color-promotion-s1">ندارد</span>
              )
            }
          />
          <Column
            title="تاریخ انقضا"
            key="stock"
            render={(sellerProduct) =>
              sellerProduct.expire_date ? (
                <span>{sellerProduct.expire_date}</span>
              ) : (
                <span className="color-promotion-s1">ندارد</span>
              )
            }
          /> */}
        </Table>
      </div>
    </Loading>
  );
};
